<template>
    <div class="saas-footer" :style="{background: bgColor}" :class="{'nobar': !hasTabBar}">
        <p class="title">
            <span class="contract" v-if="isContract" @click="showContract=true">联系我们</span>
            <span class="border" >|</span>
            <span @click="go('privacy')">法律声明及隐私政策</span>
        </p>
        <p class="sub-title">
            违法和不良信息举报电话： 400-8555-686
        </p>
        <p>
            <span> {{copyright || '©2020-2022 wdeduc.com 版权所有'}}</span>
            
        </p>
        <p>
            <img @click="jump('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035145')" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/icon/national-emblem.png" />
            <span class="nsr-number" @click="jump('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035145')">{{nsrNumber ||  '京公网安备 11010802035145号'}}</span>
            <span class="border" >|</span>
            <span @click="jump('https://beian.miit.gov.cn/#/Integrated/recordQuery')">{{ICPNumber || '京ICP备10026535号-30'}}</span>

        </p>
        <p class="last-item">
            <span v-if="showLicence">京ICP证161318号</span>
            <span class="border" v-if="showLicence">|</span>
            <span v-if="showText1">京网文{2018}2746-280号</span>
        </p>
        <van-dialog v-model="showContract" title="" :show-confirm-button="false" class="v-dialog" width="auto">
            <div class="contract-info" v-if="institutions === 'junmin'">
                <h5 style="line-height: 22px;">您在使用过程中遇到任何问题，可随时与我们联系</h5>
                <p class="txt1"><span>联系电话：</span> 0532-82669561</p>
                <p><span>联系人：</span> 薛老师、路老师</p>
                <p><span>技术支持：</span> 伟东云教育集团</p>
                <div class="callPhone">
                    <span>联系电话：</span>
                    <div>
                        <div>400-8555-686</div>
                        <!-- <div>13811317031</div> -->
                    </div>
                </div>
                 <!-- <p><span>联系人：</span> 司婷双</p> -->
                <van-icon name="cross" class="icon" @click="showContract=false"/>
            </div>
            <div v-else class="contract-info">
                <p class="txt1"><span>地址：</span> 北京市西城区北三环中路燕莎盛世大厦5层</p>
                <p><span>邮编：</span> 100029</p>
                <p><span>电话：</span> 400-8555-686</p>
                <van-icon name="cross" class="icon" @click="showContract=false"/>
            </div>
            
        </van-dialog>
    </div>
</template>
<script>
export default {
    name: 'saas-nsr-footer',
    props: {
        hasTabBar: {
            type: Boolean,
            default: true
        },
        bgColor: {
            default: '#F6F6F6',
            type: String,
        },
        isContract: {
            type: Boolean,
            default: true
        },
        institutions:{
            type: String,
            default: ''
        },
        copyright: {
            type: String,
            default: ''
        },
        nsrNumber: {
            type: String,
            default: ''
        },
        ICPNumber: {
            type: String,
            default: '' 
        },
        showLicence: {
            type: Boolean,
            default: true
        },
        showText1: {
            type: Boolean,
            default: true
        },

    },
    data() {
        return {
            showContract: false
        }
    },
    methods: {
        jump(url) {
            window.open(url, 'newW')
        },
        go(url) {
            
            const { href } = this.$router.resolve({
                path: `/${url}`
            });
            window.open(href, 'newW');
        }
    }
}
</script>
<style scoped lang="stylus">
.saas-footer
    padding 30px 30px 0
    .callPhone
        display flex
    & > p
        display flex
        // justify-content center
        font-size 20px
        color #808080
        margin 28px 0
        line-height 20px
        word-break break-all
        position relative
        &.title
            color #595959
            font-size 24px
            line-height 24px
        &.sub-title
            margin 35px 0 30px
            font-size 20px
        &:last-child
            padding-bottom 140px
        // .contract
        //     border-right 1px solid #808080
        //     margin-right 20px
        //     padding-right 20px
        &.last-item
            padding-bottom 140px
        img
            width 28px
            height 29px
            margin 0 10px 0 0
            position absolute
            left 0
            top -4px
        .border
            // border-right 1px solid #808080
            // padding 0 10px 0 0
            margin-left 10px
            margin-right 10px
        .nsr-number
            margin-left 38px
    &.nobar > p
        &:last-child
            padding-bottom 50px
    /deep/.v-dialog
        border-radius 24px
    .contract-info
        font-size 32px
        line-height 62px
        padding 72px 88px 42px
        color #202124
        position relative
        padding-bottom 60px
        text-align left 
        width 590px
        box-sizing border-box
        .icon
            position absolute
            right 20px
            top 24px
            color #9297AC
            font-size 40px
        .txt1
            padding-top 30px
</style>